//export const API_BASE_URL = "http://localhost:4000";
export const API_BASE_URL = "https://alakka.smartintegration.fi";
